import { AbstractCommand } from "./AbstractCommand"
import type { CommandResponse } from "../types"
import {
	AMSFilamentSettingResponse,
	isAMSFilamentSettingResponse,
	isPrintMessage,
} from "../responses"

export const EXTERNAL_SPOOL_AMS_ID = 255
export const VIRTUAL_TRAY_ID = 254

interface AMSFilamentSettingParams {
	/**
	 * The AMS ID to configure
	 * Use AMSFilamentSettingCommand.EXTERNAL_SPOOL_AMS_ID (255) for external spool
	 */
	ams_id: number

	/**
	 * The tray ID to configure
	 * Use AMSFilamentSettingCommand.VIRTUAL_TRAY_ID (254) for external spool
	 */
	tray_id: number

	/** The filament ID */
	filament_id: string

	/** The filament setting ID */
	setting_id: string

	/** The filament color in hex format (e.g. "FF0000FF") */
	tray_color: string

	/** The filament type (e.g. "PLA", "PETG", etc.) */
	filament_type: string

	/** Minimum nozzle temperature in Celsius */
	nozzle_temp_min: number

	/** Maximum nozzle temperature in Celsius */
	nozzle_temp_max: number
}

export class AMSFilamentSettingCommand extends AbstractCommand {
	/** Special AMS ID used for external spool */
	public static readonly EXTERNAL_SPOOL_AMS_ID = 255

	/** Special tray ID used for external spool (virtual tray) */
	public static readonly VIRTUAL_TRAY_ID = 254

	public category = "print" as const
	public command = "ams_filament_setting"


    // j["print"]["command"]       = "ams_filament_setting";
    // j["print"]["ams_id"]        = ams_id;
    // j["print"]["nozzle_temp_min"]   = nozzle_temp_min;
    // j["print"]["nozzle_temp_max"]   = nozzle_temp_max;
    // j["print"]["tray_color"]        = tray_color;
    // j["print"]["sequence_id"]   = std::to_string(MachineObject::m_sequence_id++);
    // j["print"]["tray_id"]       = tray_id;
    // j["print"]["tray_info_idx"] = filament_id;
    // j["print"]["setting_id"]    = setting_id;
    // // format "FFFFFFFF"   RGBA
    // j["print"]["tray_type"]         = tray_type;

	constructor(params: AMSFilamentSettingParams) {
		super({
			ams_id: params.ams_id,
			nozzle_temp_max: params.nozzle_temp_max,
			nozzle_temp_min: params.nozzle_temp_min,
			setting_id: params.setting_id,
			tray_color: params.tray_color,
			tray_id: params.tray_id,
			tray_info_idx: params.filament_id,
			tray_type: params.filament_type,
		})
	}

	public ownsResponse(response: CommandResponse, commandSeqId: string): response is AMSFilamentSettingResponse {
		return isAMSFilamentSettingResponse(response, commandSeqId)
	}
}
